module.exports = __webpack_public_path__ + "img/9788983925558.f0ab4ed1.jpg";